import { extension, ExtensionPriority, NodeExtension, ExtensionTag } from '@remirror/core';

var _dec, _class;
/**
 * The default text passed into the prosemirror schema.
 *
 * Extra attributes are not allowed on the text extension.
 *
 * @core
 */

var TextExtension = (_dec = extension({
  disableExtraAttributes: true,
  defaultPriority: ExtensionPriority.Medium
}), _dec(_class = class TextExtension extends NodeExtension {
  get name() {
    return 'text';
  }

  createTags() {
    return [ExtensionTag.InlineNode];
  }

  createNodeSpec() {
    return {};
  }

}) || _class);

export { TextExtension };
